'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const HistoryList = createPage(
	() => import('@/features/histories/components/HistoryList'),
	{
		LoadingComponent: () => null,
	},
);

export default function HistoryPage() {
	return <HistoryList />;
}
